import {ActionFilterParameters} from '../types'

// keys filtered on frontend without backend call
export const CLIENT_SIDE_FILTER_KEYS: (keyof ActionFilterParameters)[] = ['questionCategories']
